export default "__VITE_ASSET__BwzKjvJ1__"